import React from 'react';
import { useNetworkStatus } from '../hooks/useNetworkStatus';

export const OfflineBanner: React.FC = () => {
  const isOnline = useNetworkStatus();

  if (isOnline) {
    return null;
  }

  return (
    <div
      id="offline-banner"
      role="status"
      aria-live="polite"
      style={{
        backgroundColor: '#1e2130',
        borderBottom: '1px solid #f0a030',
        color: '#eef0f8',
        padding: '0.625rem 1rem',
        fontSize: '0.875rem',
        lineHeight: 1.4,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0.5rem',
        textAlign: 'center',
        zIndex: 1000,
      }}
    >
      <span aria-hidden="true" style={{ fontSize: '1rem', color: '#f0a030' }}>
        ⚠️
      </span>
      <span>
        <strong>You're offline.</strong> LearnOS can reconnect when your internet connection returns. Offline classroom learning may be available through your school's EduBox.
      </span>
    </div>
  );
};
